import React from "react";
import ResultsList from "./ResultsList";

// Phase 3 (M2): Résultats par objet — reference PDF page 27, which is table-only
// (no graph page). Per-lease rows grouped by module with module subtotals + grand
// total. Thin wrapper over the shared ResultsList (grouped by module_code), with
// charts disabled to match the reference.
const ResultsPerObject = (props) => (
  <ResultsList
    {...props}
    sectionTitle="Résultats par objet"
    groupOf={(o) => String(o.numero)}
    subtotalKey="module_code"
    showCharts={false}
  />
);

export default ResultsPerObject;
